import { FormatModule } from "tabulator-tables";

const { money } = FormatModule.formatters;

export default function (cell, formatterParams, onRendered) {
  if (formatterParams.zeroIsBlank && (!cell.getValue() || cell.getValue() === '£0.00')) {
    return ''
  }

  return money.bind(this)(cell, formatterParams, onRendered);
}
